import React, { useEffect, useState } from "react";
import { Placeholder } from "@/Components/";
import { useLoading } from "@/Contexts/LoadingContext";
import axios from "axios";

export function GidasFeed({ children, className = "", count = 3 }) {
  const { setIsLoaded, isLoaded } = useLoading();
  const [newsItems, setNewsItems] = useState([]);
  const [error, setError] = useState(false);

  useEffect(() => {
    axios
      .post("/api/getnews")
      .then((response) => {
        setIsLoaded(true);
        setNewsItems(response.data);
      })
      .catch((error) => {
        setError(error?.response?.data?.error || true);
        setIsLoaded(true);
      });
  }, []);

  const TextPlaceholder = (props) => {
    return isLoaded ? (
      <>{props.children}</>
    ) : (
      <Placeholder
        width={props.width}
        height={`${props.height}px`}
        className="mb-2"
      />
    );
  };

  return (
    <div
      className={`mb-8 flex flex-col items-center justify-center gap-3 md:flex-row ${className}`}
    >
      {!isLoaded ? (
        Array.from({ length: count }).map((a, i) => (
          <div key={i} className="w-full md:w-1/3">
            <Placeholder width="100%" height="200px" className="mb-2" />
            <TextPlaceholder width="80%" height={18} />
            <TextPlaceholder width="100%" height={48} />
          </div>
        ))
      ) : newsItems.length > 0 ? (
        newsItems.map((item, i) => (
          <div
            key={i}
            className="flex w-full flex-col items-start self-start md:w-1/3 mb-4"
          >
            <img
              src={item.image}
              className="mb-2 h-auto w-full object-cover md:h-48"
            />
            <span className="text-[18px] font-bold">{item.title}</span>
            <div
              className="mb-2"
              dangerouslySetInnerHTML={{ __html: item.excerpt }}
            ></div>
            <a
              className="btn-outline border-primary"
              href={item.link}
              target="_blank"
            >
              Read article
            </a>
          </div>
        ))
      ) : error ? (
        <div>{error}</div>
      ) : (
        <div>No news items</div>
      )}
    </div>
  );
}
